import React from "react";
import { motion } from "framer-motion";
import { ASSETS, COMPANY } from "@/data/site";

export const LoadingScreen = () => {
  return (
    <motion.div
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center navy-gradient grain overflow-hidden"
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      data-testid="loading-screen"
    >
      {/* concentric compass rings */}
      <div className="relative flex items-center justify-center">
        <motion.span
          className="absolute rounded-full border border-white/10"
          style={{ width: 220, height: 220 }}
          animate={{ rotate: 360 }}
          transition={{ duration: 18, repeat: Infinity, ease: "linear" }}
        />
        <motion.span
          className="absolute rounded-full border border-[color:var(--ssa-turquoise)]/30"
          style={{ width: 160, height: 160 }}
          animate={{ rotate: -360 }}
          transition={{ duration: 12, repeat: Infinity, ease: "linear" }}
        />
        <motion.img
          src={ASSETS.emblem}
          alt="Speed Shipping Agencies"
          className="h-24 w-24 object-contain"
          initial={{ scale: 0.85, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        />
      </div>

      <motion.div
        className="mt-10 text-center"
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.25, duration: 0.6 }}
      >
        <div className="font-display text-white text-xl tracking-[0.08em]">SPEED SHIPPING AGENCIES</div>
        <div className="mt-2 eyebrow text-turquoise" style={{ letterSpacing: "0.32em" }}>
          {COMPANY.tagline}
        </div>
      </motion.div>

      <div className="mt-8 h-[2px] w-40 overflow-hidden rounded-full bg-white/10">
        <motion.div
          className="h-full bg-[color:var(--ssa-turquoise)]"
          initial={{ x: "-100%" }}
          animate={{ x: "100%" }}
          transition={{ duration: 1.1, repeat: Infinity, ease: "easeInOut" }}
          style={{ width: "60%" }}
        />
      </div>
    </motion.div>
  );
};
